import { SlashMenuType } from './slashMenuTypes';

export const slashMenuMappings: Record<
  SlashMenuType,
  { icon: string; label: string }
> = {
  paragraph: { icon: '📝', label: 'Paragraph' },
  heading1: { icon: '🔠', label: 'Heading 1' },
  heading2: { icon: '🔡', label: 'Heading 2' },
  heading3: { icon: '🔤', label: 'Heading 3' },
  todo: { icon: '☑️', label: 'To-do list' },
  bulletList: { icon: '•', label: 'Bulleted list' },
  orderedList: { icon: '1.', label: 'Numbered list' },
  blockquote: { icon: '❝', label: 'Quote' },
  divider: { icon: '⎯', label: 'Divider' },
  codeBlock: { icon: '💻', label: 'Code' }
};
